// fill in both in order to get proper intellisense
export type BaseDict = {
    NoMarketsAvailable: string
}
export const BaseDict: BaseDict = {
    NoMarketsAvailable: "No markets Available"
}